"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiversityOverlayNavigation = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importStar(require("styled-components"));
const DiversityOverlay_1 = require("../../../components/pages/DiversityOverlay");
const hooks_1 = require("../../hooks");
function DiversityOverlayNavigation() {
    const { modelSave, state } = (0, hooks_1.useDiversityOverlay)();
    const location = (0, react_router_dom_1.useLocation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const isPreview = (location === null || location === void 0 ? void 0 : location.pathname) === DiversityOverlay_1.DiversityRoutes.SettingsPreview;
    const isOnboardingPage = location.pathname === DiversityOverlay_1.DiversityRoutes.Onboarding;
    const isPhenotype = location.pathname === DiversityOverlay_1.DiversityRoutes.Phenotype;
    const isSkinTone = location.pathname === DiversityOverlay_1.DiversityRoutes.SkinTone;
    const totalSlides = (state === null || state === void 0 ? void 0 : state.isOnboarding) ? 3 : 2;
    const activeIndex = (0, react_1.useMemo)(() => {
        let newIndex = 0;
        if (isOnboardingPage) {
            newIndex = 0;
        }
        else if (isPhenotype) {
            newIndex = state.isOnboarding ? 1 : 0;
        }
        else if (isSkinTone) {
            newIndex = state.isOnboarding ? 2 : 1;
        }
        else if (isPreview) {
            newIndex = state.isOnboarding ? 3 : 2;
        }
        return newIndex;
    }, [
        isOnboardingPage,
        isPhenotype,
        isSkinTone,
        isPreview,
        state.isOnboarding,
    ]);
    if (isPreview) {
        return null;
    }
    const isVisibleBackButton = state.isOnboarding
        ? !isOnboardingPage
        : !isPhenotype;
    const onNextButton = () => {
        if (state.selectedPhenotype && state.selectedSex) {
            navigate(DiversityOverlay_1.DiversityRoutes.SkinTone);
        }
    };
    const onModelSave = () => {
        if (!!state.selectedSkinTone) {
            modelSave();
            navigate(DiversityOverlay_1.DiversityRoutes.SettingsPreview);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(NavigationContainer, { "data-e2e": 'DiversityOverlayNavigation_NavigationContainer', children: [(0, jsx_runtime_1.jsx)(CircleControls, { count: totalSlides, selectedIndex: activeIndex, size: ui_1.PageControlSize === null || ui_1.PageControlSize === void 0 ? void 0 : ui_1.PageControlSize.Big, circleColor: (0, ui_1.getTheme)().greenSecondary, filled: true, withBorder: true, "data-e2e": 'DiversityOverlayNavigation_CircleControls' }), (0, jsx_runtime_1.jsxs)(Buttons, { "data-e2e": 'DiversityOverlayNavigation_Buttons', children: [isVisibleBackButton && ((0, jsx_runtime_1.jsx)(BackButton, { onClick: () => navigate(-1), role: "button", "data-e2e": 'DiversityOverlayNavigation_BackButton', children: (0, i18n_1.Localized)(i18n_1.Strings.quizzes.edit.preview.back) })), isOnboardingPage && ((0, jsx_runtime_1.jsx)(NextButton, { onClick: () => navigate(DiversityOverlay_1.DiversityRoutes.Phenotype), "$isActive": true, role: "button", "data-e2e": 'DiversityOverlayNavigation_NextButton', children: (0, i18n_1.Localized)(i18n_1.Strings.diversity.goToButton) })), !isOnboardingPage && isPhenotype && ((0, jsx_runtime_1.jsx)(NextButton, { onClick: onNextButton, "$isActive": !!(state.selectedPhenotype && state.selectedSex), role: "button", "data-e2e": 'DiversityOverlayNavigation_NextButton', children: (0, i18n_1.Localized)(i18n_1.Strings.lectures.next) })), !isOnboardingPage && isSkinTone && ((0, jsx_runtime_1.jsx)(NextButton, { onClick: onModelSave, "$isActive": !!state.selectedSkinTone, role: "button", "data-e2e": 'DiversityOverlayNavigation_NextButton', children: (0, i18n_1.Localized)(i18n_1.Strings.diversity.saveModel) }))] })] }));
}
exports.DiversityOverlayNavigation = DiversityOverlayNavigation;
const NavigationContainer = styled_components_1.default.div `
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 70px;

  color: ${({ theme }) => theme.text};

  font-weight: normal;
  font-size: 16px;

  margin-right: 4px;
  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    padding-bottom: 12px;
    height: 48px;
  `)};

  ${ui_1.deviceLandscape.laptop((0, styled_components_1.css) `
    height: 80px;
  `)};
`;
const CircleControls = (0, styled_components_1.default)(ui_1.PageControl) `
  padding-left: 40px;

  margin: 0;

  ${ui_1.devicePortrait.mobileS((0, styled_components_1.css) `
    padding-left: 20px;
  `)}

  ${ui_1.devicePortrait.mobileL((0, styled_components_1.css) `
    padding-left: 40px;
  `)}
`;
const Buttons = styled_components_1.default.div `
  display: flex;
  margin-right: 4px;

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    margin-bottom: 12px;
  `)};

  ${ui_1.deviceLandscape.laptop((0, styled_components_1.css) `
    margin: auto 4px auto auto;
  `)};
`;
const BackButton = (0, ui_1.withA11y)((0, styled_components_1.default)(ui_1.BaseButton) `
  box-sizing: content-box;

  width: 59px;
  height: 28px;

  margin: auto 12px auto auto;
  padding: 0;

  color: ${({ theme }) => theme.settings.text};

  font-weight: 400;
  line-height: 1;

  background: none;

  border-radius: 4px;

  &:focus {
    outline: ${({ theme }) => theme.greenSecondary} solid 2px;
  }

  &.onMouse:focus {
    outline: none;
  }

  &:focus-visible {
    outline: ${({ theme }) => theme.greenSecondary} solid 2px;
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }
`);
const NextButton = (0, ui_1.withA11y)((0, styled_components_1.default)(ui_1.PrimaryButton) `
  position: relative;

  width: fit-content;
  height: 36px;

  margin: auto 12px auto auto;
  padding: 10px 24px;

  color: ${({ $isActive, theme }) => $isActive ? theme.background : theme.disabledButton};

  line-height: 1;
  text-transform: uppercase;

  background-color: ${({ $isActive, theme }) => $isActive ? theme.green : theme.settings.header};
  border-radius: 4px;

  cursor: ${({ $isActive }) => ($isActive ? 'pointer' : 'default')};

  &:focus {
    outline: ${({ theme }) => theme.greenSecondary} solid 2px;
    outline-offset: 6px;
  }

  &.onMouse:focus {
    outline: none;
  }

  &:focus-visible {
    outline: ${({ theme }) => theme.greenSecondary} solid 2px;
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  ${ui_1.deviceLandscape.laptop((0, styled_components_1.css) `
    height: 40px;
  `)};
`);
